import { ChevronIcon } from '@common/components/icons';
import * as styles from '@common/components/Accordion/Accordion.module.css';

export default function Accordion({
  icon,
  title,
  borderColor,
  items = [],
  isOpen,
  onToggle,
  renderItem,
}) {
  if (!items || items.length === 0) {
    return null;
  }

  return (
    <div className={styles.accordion}>
      <button
        type="button"
        className={styles.header}
        style={borderColor ? { borderLeft: `4px solid ${borderColor}` } : undefined}
        onClick={onToggle}
        aria-expanded={isOpen}
      >
        <div className={styles.headerContent}>
          {icon && (
            <span className={styles.icon}>
              {icon}
            </span>
          )}
          <span className={styles.title}>
            {title}
          </span>
        </div>
        <span className={`${styles.chevron} ${isOpen ? styles.chevronOpen : ''}`}>
          <ChevronIcon />
        </span>
      </button>

      <div className={`${styles.content} ${isOpen ? styles.contentOpen : ''}`}>
        <div className={styles.contentInner}>
          <ul className={styles.itemList}>
            {items.map((item, index) => (
              <li
                key={item.uuid_host || item.id || index}
                className={`${styles.item} ${index % 2 === 1 ? styles.itemEven : ''}`}
              >
                {renderItem ? renderItem(item, index) : (
                  <span>{item.name || item.label || String(item)}</span>
                )}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}
